// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PartnerReferralTableRecord_wrapper__3ulj_","wrapper__header":"PartnerReferralTableRecord_wrapper__header__1B2uV"};